document.addEventListener("DOMContentLoaded", function () {
    let tabs = document.querySelectorAll(".tab-link");
    let contents = document.querySelectorAll(".tab-content");

    tabs.forEach((tab, index) => {
        tab.addEventListener("click", function () {
            // Remove 'current' class from all tabs
            tabs.forEach((t) => t.classList.remove("current"));
            contents.forEach((c) => c.classList.remove("current"));

            // Add 'current' class to the clicked tab and corresponding content
            this.classList.add("current");
            contents[index].classList.add("current");
        });
    });

    // A11y: tab strips carry role="tab" (dev-product-tabs, section-tab-collections).
    // Keep aria-selected in step with the "current" class, whichever script
    // switches it — this handler or the theme's own tabs code in theme.js.
    document.querySelectorAll('[role="tablist"]').forEach((list) => {
        const sync = () => {
            const roleTabs = list.querySelectorAll('[role="tab"]');
            if (!list.querySelector('[role="tab"].current')) return;
            roleTabs.forEach((t) => t.setAttribute("aria-selected", t.classList.contains("current") ? "true" : "false"));
        };
        new MutationObserver(sync).observe(list, { subtree: true, attributes: true, attributeFilter: ["class"] });
    });



    $(document).on('click', '.product__page [data-popout-option]', function (e) {
      e.preventDefault();
    
      var $option = $(this);
      var $popout = $option.closest('.select-popout');
      var $toggleText = $popout.find('[data-popout-toggle-text]');
      var $input = $popout.find('[data-popout-input]');
    
      var fullText = $option.find('span').text().trim();
    
      $toggleText.text(fullText);
    
      var selectedValue = $option.data('value');
      $input.val(selectedValue);
    
      $popout.find('.select-popout__item').removeClass('is-active');
      $option.closest('li').addClass('is-active');
    });

  
});
